import { Component, OnInit, Input } from '@angular/core';
import * as moment from 'moment';
import { DashboardService } from 'src/app/services/dashboard-services/dashboard.service';

@Component({
  selector: 'app-dashboard-breadcrumb',
  templateUrl: './dashboard-breadcrumb.component.html',
  styleUrls: ['./dashboard-breadcrumb.component.scss']
})
export class DashboardBreadcrumbComponent implements OnInit {

  @Input() centers;
  @Input() selectedCenters;
  @Input() limit = 4;
  @Input() hideDateSelector = false;
  selectedTimeInterval = 'day';
  pickerDateFrom;
  pickerDateTo;

  dateFrom;
  dateTo;

  constructor(private dashboardService: DashboardService) { }

  ngOnInit() {
    this.valuesChanged();
  }

  public reloadStatistics() {
    this.dashboardService.reloadStatistics(this.selectedCenters, this.dateFrom, this.dateTo);
  }

  public valuesChanged() {
    switch (this.selectedTimeInterval) {
      case 'day':
        this.dateFrom = moment().startOf('day');
        this.dateTo = moment();
        this.pickerDateFrom = null;
        this.pickerDateTo = null;
        this.reloadStatistics();
        break;
      case 'month':
        this.dateFrom = moment().startOf('month');
        this.dateTo = moment();
        this.pickerDateFrom = null;
        this.pickerDateTo = null;
        this.reloadStatistics();
        break;
      case 'year':
        this.dateFrom = moment().startOf('year');
        this.dateTo = moment();
        this.pickerDateFrom = null;
        this.pickerDateTo = null;
        this.reloadStatistics();
        break;
    }
  }

  public customDateChanged() {
    if ((this.selectedTimeInterval === 'custom') && this.pickerDateFrom && this.pickerDateTo) {
      this.dateFrom = this.pickerDateFrom;
      this.dateTo = this.pickerDateTo.endOf('day');
      this.reloadStatistics();
    }
  }

  public receiveSelectedCenters(e) {
    const aux = new Array();
    for (const i of e) {
      aux.push(i[1].data);
    }
    if (aux) {
      this.selectedCenters = aux;
      this.reloadStatistics();
    }
  }
}
